module.exports = __webpack_public_path__ + "static/assets/34681d6734afe946503f0bfa996611e5.gif";